export default Object.freeze({
  OTHER: 0,
  SCOPE: 1,
  PROPERTY: 2,
  PUBLIC: 3,
  MARKET_RENT: 4,
  LEASE_COMPS: 5,
  RENT_SURVEY_COMPS: 17,
  SALES_COMPS: 6,
  SALES_INFO: 7,
  LAND_COMPS: 8,
  IE_COMPS: 9,
  CALCULATIONS: 10,
  DOCUMENTS: 11,
  REPORT: 12,
  READER: 13,
  LEASE_RESEARCH: 14,
  SALES_RESEARCH: 15,
  LAND_RESEARCH: 16,
});
